import PrepSheetConfiguration from './prep-sheet-configuration';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { LocalDate } from '../utils/local-date';
import type SiteMenuOrder from './site-menu-order';

@JsonApiResource({
  type: 'prep-sheet-revision',
})
export default class PrepSheetRevision extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) serviceDate = new LocalDate();
  saveToDatabase: boolean = false;
  pdfUrl: string | undefined = undefined;
  affectedByNewOrderRevision: boolean = false;

  @JsonApiRelationship('prep-sheet-configuration') prepSheetConfiguration: PrepSheetConfiguration =
    new PrepSheetConfiguration(undefined, [], [], undefined, undefined, undefined);

  @JsonApiRelationship('prep-sheet-revision') prepSheetRevision: PrepSheetRevision | undefined =
    undefined;

  @JsonApiRelationship('site-menu-order') siteMenuOrders?: SiteMenuOrder[] = [];
}
